import React, {useState, useEffect, useCallback, forwardRef, useImperativeHandle} from 'react';
import {Input, Table, Col, Row, Typography, Button, message} from 'antd';
import {PlusOutlined, SearchOutlined} from '@ant-design/icons';
import api from '../../services/api';
import useBreakPoints from "../../hooks/useBreakPoint";

const {Search} = Input;

const DEFAULT_PAGE_SIZE = 10;

const SearchTable = forwardRef(function SearchTable({
                                        url,
                                        params = {},
                                        columns,
                                        rowKey = 'id',
                                        title,
                                        extra,
                                        showSearch = true,
                                        buttonProps,
                                        buttonClick,
                                        expandable,
                                    }, ref) {
    const [search, setSearch] = useState('');
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [loading, setLoading] = useState(false);
    const {isXsBreakPoint} = useBreakPoints();

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await api.get(url, {
                params: {
                    ...params,
                    search,
                    page_size: pageSize,
                    page: page ,
                }
            });
            setData(response.data.results);
            setTotal(response.data.count);
        } catch (error) {
            message.error('Erro ao carregar dados');
        } finally {
            setLoading(false);
        }
    }, [url, search, page, pageSize]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useImperativeHandle(ref, () => ({
        refetch: fetchData
    }));

    const handleSearch = (value) => {
        setSearch(value);
        setPage(1);
    };

    const handleTableChange = (pagination) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    return (

        <Row gutter={[16, 16]} >
            <Col xs={24}>
                <Typography.Title level={4} style={{marginTop: 0}}>{title}</Typography.Title>
            </Col>
            {showSearch && (<Col xs={24} lg={12}>

                <Search
                    placeholder="Pesquisar..."
                    allowClear
                    enterButton={<SearchOutlined/>}
                    size="large"
                    onSearch={handleSearch}
                    style={{marginBottom: 16}}
                />

            </Col>)}
            {buttonProps?.onClick && <Col xs={24} lg={showSearch?12:24} style={{textAlign: 'right'}}>
                <Button
                    block={isXsBreakPoint}
                    type="primary"
                    icon={<PlusOutlined/>}
                    onClick={buttonProps?.onClick}
                >
                    {buttonProps?.label}
                </Button>
            </Col>}
            <Col xs={24}>
                <Table
                    columns={columns}
                    dataSource={data}
                    rowKey={rowKey}
                    loading={loading}
                    expandable={expandable}
                    // scroll={{ x: 'max-content' }}
                    onChange={handleTableChange}
                    pagination={{
                        current: page,
                        pageSize: pageSize,
                        total: total,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} itens`
                    }}
                />
            </Col>
        </Row>

    );
});

export default SearchTable;